import { render, staticRenderFns } from "./TheMainMenu.vue?vue&type=template&id=c7b65e5a&"
import script from "./TheMainMenu.vue?vue&type=script&lang=js&"
export * from "./TheMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheMainMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports